export default {"src":"/_next/static/media/hrimnFavicon.b2d15f0e.ico","height":256,"width":256,"blurWidth":0,"blurHeight":0};